import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { Section } from 'foundations-components/transitional/components/Section';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import FinishedContainer from '../../../components/FinishedContainer.migrated';
import RetakeExamButton from './RetakeExamButton';
import { useUserInfo } from '../../accounts';
import { LANGUAGE_STRINGS } from '../../../components/Languages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getPassDate(mostRecentExamAttempt, award) {
  if (award) {
    return award.renewedAt || award.awardedAt;
  }
  if (mostRecentExamAttempt) {
    var _mostRecentExamAttemp;
    return (_mostRecentExamAttemp = mostRecentExamAttempt.attemptFinishTime) !== null && _mostRecentExamAttemp !== void 0 ? _mostRecentExamAttemp : null;
  }
  return null;
}
export default function ExamLinkedLanguage({
  award,
  trackId,
  language,
  linkedLanguage,
  trackName,
  mostRecentExamAttempt
}) {
  const {
    userInfo
  } = useUserInfo();
  const passDateForLinkedLanguageExam = getPassDate(mostRecentExamAttempt, award);
  const {
    isTablet
  } = useMediaQuery();
  const languageKey = language.toLowerCase();
  const linkedLanguageKey = linkedLanguage.toString().toLowerCase();
  const ctaText = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "learningCenter.exams.finished.retakeButtonLinkedLanguage",
    options: {
      language: LANGUAGE_STRINGS[languageKey]
    }
  });
  return /*#__PURE__*/_jsx(FinishedContainer, {
    body: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(H3, {
        "data-test-id": "exam-linked-language-heading",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.finished.successHeading",
          options: {
            firstName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.firstName
          }
        })
      }), /*#__PURE__*/_jsx(Section, {
        "data-test-id": "exam-linked-language-subheading",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.exams.finished.passedOnSubHeadingLinkedTrack",
          options: {
            courseName: trackName,
            linkedLanguage: LANGUAGE_STRINGS[linkedLanguageKey],
            language: LANGUAGE_STRINGS[languageKey],
            passDate: passDateForLinkedLanguageExam ? /*#__PURE__*/_jsx(FormattedDateTime, {
              format: "ll",
              value: passDateForLinkedLanguageExam
            }) : null
          }
        })
      }), /*#__PURE__*/_jsx(Section, {
        "data-test-id": "exam-linked-language-callToAction",
        children: /*#__PURE__*/_jsx(TrackViewAwardLink, {
          award: award,
          certification: true,
          trackId: trackId
        })
      })]
    }),
    footer: isTablet ? /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "stretch",
        flexDirection: "column",
        children: /*#__PURE__*/_jsx(RetakeExamButton, {
          ctaText: ctaText,
          mostRecentExamAttempt: mostRecentExamAttempt,
          use: "tertiary-light",
          withTooltip: true
        })
      })
    }) : /*#__PURE__*/_jsx(RetakeExamButton, {
      ctaText: ctaText,
      mostRecentExamAttempt: mostRecentExamAttempt,
      use: "tertiary-light",
      withTooltip: true
    }),
    illustration: /*#__PURE__*/_jsx(Pictogram, {
      name: "CelebrationSuccess"
    })
  });
}